<template  lang="pug">
v-card.elevation-0.pa-4.py-6(:disabled="isLoading")
  v-layout(align-center justify-center)
    div( class='text-xs-center', v-if="!showInfo")
      v-alert(text='' border="left"   type='info' icon='info', dense)
        .d-flex.fd-column
          small.font-size-12.font-weight-600  Requerimiento de cambio de contraseña
          small.font-size-11   Te enviaremos un link con las instrucciones para restablecer tu contraseña.
      v-form
        v-text-field(light prepend-icon='email'  v-model="email" ref="usuarioResetPassword" label='Ingresa un usuario valido (email)' type='email')
        v-btn( @click="fetchRestablecerContraseña()"  block color="primary" :loading="isLoading")
          small Continuar
      .d-flex.jc-center.ai-center.mt-4
        span.font-size-12 ¿Deseas Iniciar sesión?
        v-btn.ml-2( small, color="secondary primary--text"   @click="goTo('/')") click aquí

    .d-flex.fd-column(v-else)
      v-alert( color="success" text border="left")
        .d-flex.fd-column
          small.font-size-15.font-weight-700.mb-1 ¡Casi terminamos!
          small.font-size-12.mt-2  Consulta tu correo electrónico, te hemos enviado las instrucciones necesarias para recuperar tu contraseña.
      v-btn.mt-1( @click="goTo('/')"  block color="primary" :loading="isLoading")
        small Iniciar sesión
</template>
<script>
import { notify } from '../util/general'
import Router from '../router/not_logged.js'
export default {
  data () {
    return {
      email    : '',
      isLoading: false,
      showInfo : false
    }
  },
  methods : {
    goTo (page) {
      var  vm = this
      Router.push(page)
      vm.showInfo = false
    },
    fetchRestablecerContraseña () {
      var vm          = this
      if (vm.email === '') {
        notify(vm, 'error', 'Error', 'El campo de del email se encuentra vacio')
        vm.$refs.usuarioResetPassword.focus()
        return
      }

      vm.isLoading = true
      var obj = {
        email  : vm.email,
        empresa: process.env.EMPRESA
      }

      vm.axios.post('/usuario/forgot-password-request', obj).then((response) => {
        if (response.data.status === 1) {
          vm.showInfo = true
        } else {
          notify(vm, 'error', 'Error', response.data.message)
        }
        vm.isLoading = false
      }).catch((error) => {
        notify(vm, 'error', 'Error', error.message)
        vm.isLoading = false
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
</style>



// WEBPACK FOOTER //
// Forgot_password_request.vue?634a3370